import { Component, inject } from "@angular/core";
import { Title } from "@angular/platform-browser";
import { LgTranslateService } from "@logex/framework/lg-localization";

@Component({
    selector: "mrdm-self-service-frontend-root",
    templateUrl: "./app.component.html",
    styleUrls: ["./app.component.scss"],
    standalone: false
})
export class AppComponent {
    private _title = inject(Title);
    private _translate = inject(LgTranslateService);

    constructor() {
        this._title.setTitle(this._translate.translate("APP.Title.Main"));
    }
}
